var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_23012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 4H8C5.8 4 4.02 5.8 4.02 8L4 44L12 36H40C42.2 36 44 34.2 44 32V8C44 5.8 42.2 4 40 4ZM34 28H14C12.9 28 12 27.1 12 26C12 24.9 12.9 24 14 24H34C35.1 24 36 24.9 36 26C36 27.1 35.1 28 34 28ZM34 22H14C12.9 22 12 21.1 12 20C12 18.9 12.9 18 14 18H34C35.1 18 36 18.9 36 20C36 21.1 35.1 22 34 22ZM34 16H14C12.9 16 12 15.1 12 14C12 12.9 12.9 12 14 12H34C35.1 12 36 12.9 36 14C36 15.1 35.1 16 34 16Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_23012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.bd088fe252a6555c5e33a25928f12714.svg";
export { ForwardRef as ReactComponent };